export default {
    firstToCreate: 'Wees de eerste om een discussie in dit forum te starten',
    firstToPostInCategory: 'Wees de eerste om in deze categorie te posten',
    firstToRespondToTopic: 'Wees de eerste om op dit onderwerp te reageren!',
    createNewThread: 'Nieuwe discussie starten',
    thread: 'discussie',
    viewThread: 'Bekijk discussie',
    replies: 'Reacties',
    noReplies: 'Geen reacties',
    reply: 'reageer',
    _reply: 'Reageer',
    ReplyTo: 'Reageer op',
    replyToThisQuestion: 'Reageer op deze vraag',
    onceRepliedModeratorMayRespond: 'Zodra je hebt gereageerd, kan de forumbeheerder op je reactie reageren',
    onceRepliedCanViewResponses: 'Zodra je hebt gereageerd, kun je de reacties van andere deelnemers bekijken',
    loadingResponses: 'Reacties laden',
    hideXReplies: 'Verberg {count} reacties',
    showXReplies: 'Toon {count} reacties',
    hideMostRecentReplies: 'Verberg meest recente reacties',
    showMostRecentReplies: 'Toon meest recente reacties',
    post: 'Plaatsen',
    message: 'Bericht',
    typeMessage: 'Typ een bericht',
    addPost: 'Plaats bericht',
    addMessage: 'Voeg bericht toe',
    editPost: 'Bewerk bericht',
    editPostWithMedia: 'Bewerk bericht met media',
    createPostWithMedia: 'Maak bericht met media',
    deleteMessage: 'Verwijder bericht',
    deleteMessageConfirm: 'Weet je zeker dat je dit bericht wilt verwijderen?',
    pinPost: 'Bericht vastzetten',
    media: 'Media',
    uploadMedia: 'Upload media',
    categories: 'categorieën',
    goBack: 'Ga terug',
    goBackPrevious: 'Ga terug naar de vorige pagina',
    goBackToCategory: 'Ga terug naar de categorie {name}',
    loadingLatestThreads: 'Laatste discussies laden',
    loadingDiscussionForum: 'Discussieforum laden',
    dontShowAgainForTask: `Niet meer tonen voor deze taak`,
    title: 'Titel',
    beTheFirst: 'Be the first to reply to this thread'
};
